// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64680":"e11fcf53","75714":"bdd46046"}[chunkId] + ".chunk.css";
};